// extracted by mini-css-extract-plugin
module.exports = {"overlap":"BodyPhone_overlap_J-cpH","device":"BodyPhone_device_1uF8P","loading":"BodyPhone_loading_3IcyC","bg":"BodyPhone_bg_1Meo2"};